import { render, staticRenderFns } from "./extension.vue?vue&type=template&id=233db917"
import script from "./extension.vue?vue&type=script&lang=js"
export * from "./extension.vue?vue&type=script&lang=js"
import style0 from "./extension.vue?vue&type=style&index=0&id=233db917&prod&lang=css"
import style1 from "./extension.vue?vue&type=style&index=1&id=233db917&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports